export { useGetRetailerLabel } from './use-get-retailer-label';
